import React, { Fragment } from 'react';
import Helmet from 'react-helmet';

import Icon from '../../components/Icon/Icon';
import FilmSlider from '../../components/FilmSlider/FilmSlider';
import PageNotFound from '../../pages/PageNotFound/PageNotFound';

import tubiImg from '../../assets/images/tubi-big.jpg';
import imdbImg from '../../assets/images/imdb.jpg';
import primeImg from '../../assets/images/primevideo.jpg';

import './FilmPage.scss';

class FilmPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      loading: true,
      film: [],
      metadata: []
    };
  }

  componentDidMount() {
    this.mounted = true;
    const {
      match: { params }
    } = this.props;

    fetch(
      `https://stephengrahamprojects.com/backend/wp-json/api/v1/films/${params.slug}`
    )
      .then(res => res.json())
      .then(
        result => {
          this.setState({
            film: result,
            loading: false
          });
        },
        error => {
          this.setState({
            error,
            loading: false
          });
        }
      );
  }

  renderPage() {
    const { error, film } = this.state;
    console.log('film', film);
    const filmMarkup = film.map((filmData, i) => {
      const {
        title,
        synopsis,
        // heroBanner,
        thumbnail,
        duration,
        releaseDate,
        producer,
        director,
        editor,
        videoId,
        sgp_vod,
        imdb,
        prime,
        tubi,
        buyAmazon,
        slug,
        metadata = []
      } = filmData;
      const { seoTitle, seoDescription, seoTags } = metadata;

      return (
        <Fragment>
          <div className="container" key={i}>
            <Helmet
              title={
                seoTitle
                  ? seoTitle
                  : 'Stephen Graham Projects | Documentarian, Trauma-Informed Practice, Youth & Community Work'
              }
              meta={[
                {
                  name: 'description',
                  content: seoDescription
                },
                {
                  name: 'keywords',
                  content: seoTags
                },
                {
                  property: 'og:type',
                  content: 'website'
                },
                {
                  property: 'og:url',
                  content: `https://stephengrahamprojects.com/filmmaker/${slug}`
                },
                {
                  property: 'og:title',
                  content: seoTitle
                },
                {
                  property: 'og:description',
                  content: seoDescription
                },
                {
                  property: 'og:image',
                  content: thumbnail
                },
                {
                  property: 'twitter:card',
                  content: 'summary_large_image'
                },
                {
                  property: 'twitter:url',
                  content: `https://stephengrahamprojects.com/filmmaker/${slug}`
                },
                {
                  property: 'twitter:title',
                  content: seoTitle
                },
                {
                  property: 'twitter:description',
                  content: seoDescription
                },
                {
                  property: 'twitter:image',
                  content: thumbnail
                }
              ]}
            />

            <div className="row py-5">
              <div className="col-md-12">
                <h1>{title}</h1>
              </div>
            </div>
            <div className="row pb-5">
              <div className="col-md-4">
                <img
                  className="w-100 mb-3 border-thick"
                  src={thumbnail}
                  alt={`Thumbnail for ${title}`}
                  style={{ maxWidth: '500px' }}
                />
                {imdb && (
                  <a
                    className="p-2 mt-1"
                    href={imdb}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Icon
                      type="img"
                      icon={imdbImg}
                      alt={`${title} on IMDb`}
                      style={{ width: '40px' }}
                      className="align-top"
                    />
                  </a>
                )}
              </div>
              <div className="col-md-8">
                <dl className="row">
                  {producer && (
                    <Fragment>
                      <dt className="col-sm-3">Produced By:</dt>
                      <dd className="col-sm-9">{producer}</dd>
                    </Fragment>
                  )}
                  {director && (
                    <Fragment>
                      <dt className="col-sm-3">Directed By:</dt>
                      <dd className="col-sm-9">{director}</dd>
                    </Fragment>
                  )}
                  {editor && (
                    <Fragment>
                      <dt className="col-sm-3">Edited By:</dt>
                      <dd className="col-sm-9">{editor}</dd>
                    </Fragment>
                  )}
                  {releaseDate && (
                    <Fragment>
                      <dt className="col-sm-3">Release Date:</dt>
                      <dd className="col-sm-9">{releaseDate}</dd>
                    </Fragment>
                  )}
                  {duration && (
                    <Fragment>
                      <dt className="col-sm-3">Duration:</dt>
                      <dd className="col-sm-9">{duration}</dd>
                    </Fragment>
                  )}
                </dl>
                {(prime || tubi || sgp_vod) && (
                  <div className="row">
                    <div className="col-sm-12 related-links">
                      <ul className="nav">
                        {sgp_vod && (
                          <li className="nav-link pl-0">
                            <a
                              href={sgp_vod}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <button className="btn btn-outline-grey font-weight-bold border-2">
                                Watch now on SGP VOD
                              </button>
                            </a>
                          </li>
                        )}
                        {false && (
                          <li className="nav-link pl-0">
                            <a
                              href={tubi}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <Icon
                                type="img"
                                icon={tubiImg}
                                alt={`${title} on Tubi`}
                                style={{ width: '80px' }}
                                className="align-top"
                              />
                            </a>
                          </li>
                        )}
                        {false && (
                          <li className="nav-link pl-0">
                            <a
                              href={prime}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <Icon
                                type="img"
                                icon={primeImg}
                                alt={`${title} on Prime Video`}
                                style={{ width: '80px' }}
                                className="align-top"
                              />
                            </a>
                          </li>
                        )}
                        {buyAmazon && (
                          <li className="nav-link pl-0">
                            <a
                              href={buyAmazon}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <Icon
                                type="fa"
                                icon="fa-amazon"
                                alt={`${title} on Amazon`}
                              />
                            </a>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="container-fluid alt-bg p-0">
            <div className="container">
              <div className="row py-5">
                <div className="col-md-12">
                  <h3 className="text-white">Synopsis</h3>
                </div>
                <div
                  className="col-md-12 pt-2 text-white"
                  dangerouslySetInnerHTML={{ __html: synopsis }}
                />
              </div>
            </div>
          </div>
          <div className="container-fluid p-0">
            <div className="container">
              <div className="row py-5">
                <div className="col-md-12">
                  <h3>Watch</h3>
                </div>
                <div className="col-md-12 pt-2">
                  <div className="video-wrapper">
                    <iframe
                      title={title}
                      width="560"
                      height="315"
                      src={`https://www.youtube.com/embed/${videoId}?rel=0&playlist=${videoId}&autoplay=1&loop=1`}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen="allowFullScreen"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid p-0">
            <div className="container">
              <div className="row py-5">
                <div className="col-md-12">
                  <h3>More Films and Documentaries</h3>
                </div>
                <div className="col-md-12 pt-2">
                  <FilmSlider />
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      );
    });

    if (error) {
      console.warn('Error fetching modules');
    } else {
      console.log('modules fetched');
      return filmMarkup;
    }
  }

  render() {
    const { film, loading } = this.state;
    if (loading) {
      return null;
    } else {
      return film.length !== 0 ? this.renderPage() : <PageNotFound />;
    }
  }
}

export default FilmPage;
